/**
 * Created by chenwenxiao on 2016/8/19.
 */

class baseCheck {
  static pattern = {
    isMail: /^[a-z0-9]([.]?[a-z0-9\-_]+)*@[a-z0-9](-*[a-z0-9]+)*(\.[a-z0-9](-*[a-z0-9]+)*){1,4}$/i,
    isPhone: /\d{3}-\d{8}|\d{4}-\d{7}|\d{11}/,
    isMobile: /^1[2-9][0-9]{9}$/,
    isIP: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/,
    isAmount: /^[0-9]*([.][0-9]{1,2})?$/
  }

  /** ****************js内部验证******************/
  /**
   * 检查是否是function
   * @param {string} d  传入的需要检查的对象
   * @return {boolean} 返回bool值
   */
  isFunction (d) {
    return typeof d === 'function'
  }

  /**
   * 检查是否是object
   * @param {string} d  传入的需要检查的对象
   * @return {boolean} 返回bool值
   */
  isObject (d) {
    return typeof d === 'object'
  }

  /**
   * 检查是否是字符串
   * @param {string} d  传入的需要检查的对象
   * @return {boolean} 返回bool值
   */
  isString (d) {
    return typeof d === 'string'
  }

  /**
   * 检查是否是数组
   * @param {string} d  传入的需要检查的对象
   * @return {boolean} 返回bool值
   */
  isArr (d) {
    if (!d) return false
    return typeof d === 'object' && d.length !== undefined
  }

  /**
   * 长度校验
   * @param {string} big  大的数据
   * @param {string} small  小的数据
   * @return {boolean} 返回bool值
   */
  lengthCheck (big, small) {
    return big >= small
  }

  /**
   * 相等校验
   * @param {string} nval  新的数据
   * @param {string} oval  旧的数据
   * @return {boolean} 返回bool值
   */
  npwdCheck (nval, oval) {
    return nval === oval
  }

  /** **************web部分验证***************/

  /**
   * 邮箱验证
   * 邮件校验规则
    1. 邮箱格式为: 邮箱账号@邮箱域名
    2. 邮箱账号合法字符为字母/数字/下划线/短横杠/点号；
    3. 邮箱账号首字符只能为字母或数字；
    4. 邮箱账号尾字符不能为点号；
    5. 邮箱账号不能连续出现两个点号,可以连续出现多个横杠和下划线；
    6. 邮箱域名合法字符为字母/数字/短横杠；
    7. 邮箱域名每个节点首尾字符只能为字母或数字;
    8. 最多允许4级子域名, 即域名最多只能包含4个点号，例: admin.vip.sina.com.cn。
    * @param {string} d  需要校验的数据
    * @return {boolean} 返回bool值
    */
  isMail (d) {
    return baseCheck.pattern.isMail.test(d)
  }

  /**
   * 是否是数字
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isNumber (d) {
    return !isNaN(d)
  }

  /**
   * 是否是整数
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isInteger (obj) {
    return typeof obj === 'number' && obj % 1 === 0
  }
  /**
   * @author zhanhuancheng<zhanhuancheng@ukelink.com>
   * @date 2017/05/16
   * @description 是否是金额/数量, 最多两位小数
   * @param {string} d  需要校验的数据
   * @returns {boolean}
   */
  isAmount (d) {
    return baseCheck.pattern.isAmount.test(d)
  }

  /**
   * 电话验证
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isPhone (d) {
    return baseCheck.pattern.isPhone.test(d)
  }
  /**
   * 手机号验证
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isMobile (d) {
    return baseCheck.pattern.isMobile.test(d)
  }

  /**
   * 验证身份证号
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isPort (d) {
    if (d.length === 15) {
      return /^\d{15}/.test(d)
    } else if (d.length === 18) {
      return /^\d{18}\b|^\d{17}\w{1}\b/.test(d)
    }
    return false
  }

  /**
   * QQ号验证
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isQQ (d) {
    return /^[1-9]\d{4,13}$/.test(d)
  }

  /**
   * IMEI号验证
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   * 修改IMEI 验证为15位  之前为24位
   * yankang  2017/04/01
   */
  isIMEI (d) {
    let reg = /^[1-9][0-9-]*$/
    let regImei = /^(\d{4}[-]?){3}\d{3}$/
    return reg.test(d) && regImei.test(d)
  }

  /**
   * ip验证
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isIP (d) {
    return baseCheck.pattern.isIP.test(d)
  }

  /**
   * ip验证或为空
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isIPOrEmpty (d) {
    if (d === undefined || d === '') {
      return true
    } else {
      return this.isIP(d)
    }
  }

  /**
   * 邮编验证
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isZipcode (d) {
    return /^[1-9]\d{5}$/.test(d)
  }

  /**
   * 匹配正浮点数，用于金额等校验
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isPositvePoint (d) {
    return /[1-9]\d*\.\d*|^0\.\d*[1-9]\d*$/.test(d)
  }

  /**
   * 匹配负浮点数，用于金额等校验
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isNegativePoint (d) {
    return /-([1-9]\d*\.\d*|0\.\d*[1-9]\d*)$/.test(d)
  }

  /**
   * 空格检查
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  hasSpace (d) {
    return !/\s+/.test(d)
  }

  /**
   * 是否是合法字符
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isLegitimateStr (d) {
    const reg = new RegExp('^[a-zA-Z0-9_@.]{' + 1 + ',' + 2000 + '}$')
    return reg.test(d)
  }

  /**
   * 是否是合法字符
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  isLegitimateStrLength (d, min, max) {
    const reg = new RegExp('^[a-zA-Z0-9_@.]{' + (min || 1) + ',' + (max || 30) + '}$')
    return reg.test(d)
  }

  /**
   * 是否是空的字符
   * @param {string} d  需要校验的数据
   * @return {boolean} 返回bool值
   */
  notEmpty (d) {
    return d !== '' && d !== undefined && d !== null
  }
}

export default baseCheck
